export const content = {
    request: {
        request_error: "요청하신 작업 중 에러가 발생했습니다",

        request_error_in_course: "존재하지 않는 강의 입니다",

        request_error_course_expired: "현재 강의는 수강기간이 만료되었습니다😢",
    },
    login: {
        require_login_confirm: "로그인이 필요한 서비스입니다",

        empty_login: "이메일 또는 비밀번호를 입력하세요",
        empty_login_email: "이메일을 입력해주세요",
        empty_login_password: "비밀번호를 입력해주세요",

        check_login_email: "올바른 이메일 형태가 아닙니다",
        check_login_password: "비밀번호는 4자 이상 입력해주세요",

        login_failed: "이메일 또는 비밀번호를 확인해주세요",

        confirm_logout: "로그아웃 하시겠습니까?",
    },
    modify_info: {
        empty_modify_name: "이름을 입력해주세요",
        empty_modify_phone: "휴대전화를 입력해주세요",
        empty_modify_birth: "생년월일을 입력해주세요",

        check_modify_name: "이름은 한글/영어/숫자로 입력해주세요",
        check_modify_phone: "휴대전화는 010-XXXX-XXXX형식으로 입력해주세요",
        check_modify_birth: "생년월일은 YYYY-MM-DD형태로 입력해주세요",

        did_not_changed: "변경된 사항이 없습니다",

        confirm_update: "변경된 사항을 저장하시겠습니까?",

        success_update: "성공적으로 변경하였습니다",
    },
    modify_password: {
        empty_modify_password: "필수사항입니다",

        not_matched_current_password: "일치하지 않습니다",

        same_as_cur_pw: "기존 비밀번호와 새로운 비밀번호가 동일합니다",

        need_modify_new_pw: "기존 비밀번호와 다른 4자리 이상의 비밀번호를 입력해주세요",

        success_update: "성공적으로 변경되었습니다.다시 로그인 해주세요",
    },
    course_list: {
        empty_on_going: "현재 수강중인 강의가 없습니다",
        empty_expired: "수강만료된 강의가 없습니다",

        expired_course: "해당 강의는 수강기간이 만료되었습니다",
    },
    find_account: {
        does_not_exist_user: "해당 정보의 회원을 찾을 수 없습니다",

        send_init_password_to_email: "해당 이메일로 초기화된 비밀번호를 전송했습니다",
    },
};
